import React from 'react';
import cx from 'classnames';

import styles from './Text.module.scss';
import usePresenter from './Text.presenter';
import { TextCombinedProps } from './types';

const Text: React.FC<TextCombinedProps> = (props) => {
  const {
    align,
    styleType,
    colour,
    type,
    className,
    classes,
    value,
    dataTestId, // MANUAL OVERRIDE
  } = usePresenter(props);

  const variantName = `${align}${styleType}${colour}${type}`;
  const currentStyle = styles[`text${variantName}`];

  let componentView;

  switch (variantName) {
    case 'CenterMediumDarkBody4':
    case 'CenterMediumDestructiveButton1':
    case 'CenterMediumDisabledButton1':
    case 'CenterMediumInteractiveButton1':
    case 'CenterMediumInteractiveButton2':
    case 'CenterMediumLightButton1':
    case 'CenterMediumLightButton2':
    case 'CenterRegularDarkBody1':
    case 'CenterRegularDarkBody3':
    case 'CenterRegularDarkBody4':
    case 'CenterRegularSubduedBody1':
    case 'CenterRegularSubduedBody2':
    case 'LeftMediumDarkBody4':
    case 'LeftMediumDarkButton1':
    case 'LeftMediumDarkButton2':
    case 'LeftMediumDarkHeading6':
    case 'LeftMediumDestructiveButton1':
    case 'LeftMediumDisabledButton1':
    case 'LeftMediumDisabledUnderlineButton1':
    case 'LeftMediumHoverButton1':
    case 'LeftMediumHoverUnderlineButton1':
    case 'LeftMediumInteractiveButton1':
    case 'LeftMediumInteractiveUnderlineButton1':
    case 'LeftMediumPressedButton1':
    case 'LeftMediumPressedUnderlineButton1':
    case 'LeftRegularDarkBody1':
    case 'LeftRegularDarkBody2':
    case 'LeftRegularDarkBody3':
    case 'LeftRegularDarkBody4':
    case 'LeftRegularDestructiveBody2':
    case 'LeftRegularDestructiveBody4':
    case 'LeftRegularDisabledBody1':
    case 'LeftRegularDisabledBody4':
    case 'LeftRegularLightBody1':
    case 'LeftRegularPositiveBody1':
    case 'LeftRegularSubduedBody1':
    case 'LeftRegularSubduedBody3':
    case 'RightRegularLightBody1':
    case 'LeftRegularDestructiveBody1': {
      componentView = (
        <div className={cx(currentStyle, className)}>
          <p
            className={cx(styles.value, classes?.value)}
            data-testid={dataTestId} // MANUAL OVERRIDE
          >
            {value}
          </p>
        </div>
      );
      break;
    }
    case 'CenterSemiBoldDarkHeading1':
    case 'CenterSemiBoldSubduedHeading1':
    case 'LeftSemiBoldDarkHeading1':
    case 'LeftSemiBoldSubduedHeading1': {
      componentView = (
        <div className={cx(currentStyle, className)}>
          <h1
            className={cx(styles.value, classes?.value)}
            data-testid={dataTestId} // MANUAL OVERRIDE
          >
            {value}
          </h1>
        </div>
      );
      break;
    }
    case 'CenterSemiBoldDarkHeading2':
    case 'LeftSemiBoldDarkHeading2': {
      componentView = (
        <div className={cx(currentStyle, className)}>
          <h2
            className={cx(styles.value, classes?.value)}
            data-testid={dataTestId} // MANUAL OVERRIDE
          >
            {value}
          </h2>
        </div>
      );
      break;
    }
    case 'CenterSemiBoldDarkHeading3':
    case 'CenterSemiBoldInteractiveHeading3':
    case 'LeftSemiBoldDarkHeading3': {
      componentView = (
        <div className={cx(currentStyle, className)}>
          <h3
            className={cx(styles.value, classes?.value)}
            data-testid={dataTestId} // MANUAL OVERRIDE
          >
            {value}
          </h3>
        </div>
      );
      break;
    }
    case 'CenterMediumInteractiveHeading4':
    case 'CenterMediumSubduedHeading4':
    case 'LeftMediumDarkHeading4':
    case 'LeftMediumLightHeading4':
    case 'CenterSemiBoldInteractiveHeading4':
    case 'CenterSemiBoldSubduedHeading4':
    case 'LeftSemiBoldDarkHeading4':
    case 'LeftSemiBoldLightHeading4': {
      componentView = (
        <div className={cx(currentStyle, className)}>
          <h4
            className={cx(styles.value, classes?.value)}
            data-testid={dataTestId} // MANUAL OVERRIDE
          >
            {value}
          </h4>
        </div>
      );
      break;
    }
    case 'CenterMediumDarkHeading5':
    case 'CenterMediumDisabledHeading5':
    case 'CenterSemiBoldInteractiveHeading5':
    case 'CenterSemiBoldSubduedHeading5':
    case 'LeftMediumDarkHeading5':
    case 'LeftMediumDestructiveHeading5':
    case 'LeftSemiBoldDarkHeading5': {
      componentView = (
        <div className={cx(currentStyle, className)}>
          <h5
            className={cx(styles.value, classes?.value)}
            data-testid={dataTestId} // MANUAL OVERRIDE
          >
            {value}
          </h5>
        </div>
      );
      break;
    }
    case 'CenterSemiBoldDarkHeading6':
    case 'CenterSemiBoldDisabledHeading6':
    case 'CenterSemiBoldInteractiveHeading6':
    case 'CenterSemiBoldSubduedHeading6':
    case 'LeftSemiBoldDarkHeading6':
    case 'LeftSemiBoldInteractiveHeading6': {
      componentView = (
        <div className={cx(currentStyle, className)}>
          <h6
            className={cx(styles.value, classes?.value)}
            data-testid={dataTestId} // MANUAL OVERRIDE
          >
            {value}
          </h6>
        </div>
      );
      break;
    }
    default:
      componentView = <div>�</div>;
      break;
  }

  return componentView;
};

export default Text;
